import logo from "./logo.svg";
import "./App.css";
import ReactTagInput from "react-input-tag-field";
import { useState } from "react";

function App() {
  const [tags, setTags] = useState([]);
  console.log(tags, setTags);
  return (
    <div style={{marginTop: "20px"}}>
      <ReactTagInput tags={tags} setTags={setTags} />
    </div>
  );
}

export default App;
